<template>
    <section class="font-poppins">
        <div class="flex md:flex-col">
            <AdminDashboardNav/>

            <div class="w-screen">
                <div class="flex justify-between pl-10 pr-10 pt-5 md:p-2 md:flex-col-reverse">
                    <div>
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">ADMIN WALLET</p>
                    </div>
                    <div>
                        <Notification/>
                    </div>
                </div>

                <div class="p-3 flex mt-10 md:flex-col">
                    <div class="w-1/2 md:w-full">
                        <div class=" rounded-lg" style="background-color:#0048AE">
                            <AdminBalance />
                        </div>
                        <div>
                            <Transfer/>
                        </div>
                    </div>
                    <div class="w-1/3 ml-7 md:w-full md:ml-0 md:mt-4">
                        <DataInflow/>
                    </div>
                </div>

                
            </div>
        </div>
    </section>
</template>

<script>
import AdminDashboardNav from '../../AdminDashboardNav.vue';
import GetDate from '../../GetDate.vue';
import AdminBalance from './AdminBalance.vue';
import Notification from '../../Notification.vue';
import Transfer from '../AdminMainWallet/Transfer.vue';
import DataInflow from '../AdminMainWallet/DataInflow.vue';
export default {
  components: { 
      Notification,
      GetDate,
      AdminDashboardNav,
      AdminBalance, 
      Transfer,
      DataInflow
    },
    
}
</script>